(function () {
  jQuery(document).ready(function ($) {
    const cardHeaders = $(".card-header");
    cardHeaders.click(function () {
      $(this).parent().toggleClass("active");
      $(this).next().slideToggle(300);
    });

    const cardFaq = $(".card-faq .title-question");
    cardFaq.click(function () {
      $(this).parent().toggleClass("active");
      $(this).next().slideToggle();
    });

    if (localStorage["openMiniCart"] == "true") {
      document.body.classList.add("open-cart");
      document.body.classList.add("hideheader");
      localStorage["openMiniCart"] = "false";
    }
    if ($(".hero-slideshow")) {
      $(".hero-slideshow-inner").addClass("swiper-wrapper");
      $(".hero-slideshow-inner .slide-wrapper").addClass("swiper-slide");
      $(".hero-slideshow").addClass("swiper-slider");
      var swiper = new Swiper(".swiper-slider", {
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: true,
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".hero-slideshow .swiper-button-next",
          prevEl: ".hero-slideshow .swiper-button-prev",
        },
        pagination: {
          el: ".hero-slideshow .swiper-pagination",
          clickable: true,
        },
      });
    }

    $("footer .f-newsletter#f-newsletter .items .item:last-child .title-link a.button").click(function (e) {
      e.preventDefault();
      if (!document.getElementById("dummy-chat-button-iframe")) {
        document
          .querySelector("#shopify-chat iframe")
          .contentWindow.document.querySelector(".chat-toggle")
          .click();
      } else {
        document
          .getElementById("dummy-chat-button-iframe")
          .contentWindow.document.getElementById("dummy-chat-button")
          .click();
      }
      return false;
    });

    if ($(".featured-product-media")) {
      var swiper = new Swiper(".featured-product-media", {
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: true,
        loop: true,
        speed: 1000,
        // autoplay: {
        //   delay: 6000,
        //   disableOnInteraction: false,
        // },
        navigation: {
          nextEl: ".featured-product-media .swiper-button-next",
          prevEl: ".featured-product-media .swiper-button-prev",
        },
        pagination: {
          el: ".featured-product-media .swiper-pagination",
          clickable: true,
        },
      });
    }

    if ($(".wraper-content").lenghth) {
      $(".wraper-content .content").addClass("swiper-wrapper");
      $(".wraper-content .content .item").addClass("swiper-slide");
      $(".wraper-content").addClass("swiper-items");
      var swiper = new Swiper(".swiper-items", {
        slidesPerView: 3,
        spaceBetween: 0,
        allowTouchMove: true,
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 0,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
        },
      });
    }
    const windowHeight = () => {
      const doc = document.documentElement;
      doc.style.setProperty(
        "--window-height",
        `${window.innerHeight}` - $("#shopify-section-header").height() + `px`
      );
    };
    window.addEventListener("resize", windowHeight);
    windowHeight();

    $("section.image-text.intelligently a.button").click(function (e) {
      e.preventDefault();
      var idSection = $(this).attr("href");
      $("html, body").animate(
        {
          scrollTop: $(idSection).offset().top,
        },
        500
      );
    });
    $(".pre-order-header a, .hero-video .imgOverlay .hero-video__title a").click(function (e) {
      e.preventDefault();
      var idSection = $(this).attr("href");
      $("html, body").animate(
        {
          scrollTop: $(idSection).offset().top,
        },
        500
      );
    });
  });

  $(window).on("load", function () {
    if (jQuery("#hero-video-desktop").length > 0) {
      document.getElementById("hero-video-desktop").play();
    }
    if (jQuery("#hero-video-mobile").length > 0) {
      document.getElementById("hero-video-mobile").play();
    }
    if (jQuery("#product-video-seek").length > 0) {
      document.getElementById("product-video-seek").play();
    }
    if (jQuery("#functional-benefits-video").length > 0) {
      document.getElementById("functional-benefits-video").play();
    }
  });
})();

// menu js
var drawer = function () {
  /**
   * Element.closest() polyfill
   * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
   */
  if (!Element.prototype.closest) {
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
    }
    Element.prototype.closest = function (s) {
      var el = this;
      var ancestor = this;
      if (!document.documentElement.contains(el)) return null;
      do {
        if (ancestor.matches(s)) return ancestor;
        ancestor = ancestor.parentElement;
      } while (ancestor !== null);
      return null;
    };
  }

  // Trap Focus
  // https://hiddedevries.nl/en/blog/2017-01-29-using-javascript-to-trap-focus-in-an-element
  //
  function trapFocus(element) {
    var focusableEls = element.querySelectorAll(
      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
    );
    var firstFocusableEl = focusableEls[0];
    var lastFocusableEl = focusableEls[focusableEls.length - 1];
    var KEYCODE_TAB = 9;

    element.addEventListener("keydown", function (e) {
      var isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB;

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) {
        /* shift + tab */ if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus();
          e.preventDefault();
        }
      } /* tab */ else {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus();
          e.preventDefault();
        }
      }
    });
  }

  //
  // Settings
  //
  var settings = {
    speedOpen: 50,
    speedClose: 350,
    activeClass: "is-active",
    visibleClass: "is-visible",
    selectorTarget: "[data-drawer-target]",
    selectorTrigger: "[data-drawer-trigger]",
    selectorClose: "[data-drawer-close]",
  };

  //
  // Methods
  //

  // Toggle accessibility
  var toggleAccessibility = function (event) {
    if (event.getAttribute("aria-expanded") === "true") {
      event.setAttribute("aria-expanded", false);
    } else {
      event.setAttribute("aria-expanded", true);
    }
  };

  // Open Drawer
  var openDrawer = function (trigger) {
    sessionStorage.setItem('drawerOpened', 1);
    // Find target
    var target = document.getElementById(trigger.getAttribute("aria-controls"));

    // Make it active
    target.classList.add(settings.activeClass);

    // Make body overflow hidden so it's not scrollable
    document.documentElement.style.overflow = "hidden";

    // Toggle accessibility
    toggleAccessibility(trigger);

    // Make it visible
    setTimeout(function () {
      target.classList.add(settings.visibleClass);
      trapFocus(target);
    }, settings.speedOpen);
  };

  // Close Drawer
  var closeDrawer = function (event) {
    sessionStorage.setItem('drawerOpened', 0);
    // Find target
    var closestParent = event.closest(settings.selectorTarget),
      childrenTrigger = document.querySelector(
        '[aria-controls="' + closestParent.id + '"'
      );

    // Make it not visible
    closestParent.classList.remove(settings.visibleClass);

    // Remove body overflow hidden
    document.documentElement.style.overflow = "";

    // Toggle accessibility
    toggleAccessibility(childrenTrigger);

    // Make it not active
    setTimeout(function () {
      closestParent.classList.remove(settings.activeClass);
    }, settings.speedClose);
  };

  // Click Handler
  var clickHandler = function (event) {
    // Find elements
    var toggle = event.target,
      open = toggle.closest(settings.selectorTrigger),
      close = toggle.closest(settings.selectorClose);

    // Open drawer when the open button is clicked
    if (open) {
      openDrawer(open);
    }

    // Close drawer when the close button (or overlay area) is clicked
    if (close) {
      closeDrawer(close);
    }

    // Prevent default link behavior
    if (open || close) {
      event.preventDefault();
    }
  };

  // Keydown Handler, handle Escape button
  var keydownHandler = function (event) {
    if (event.key === "Escape" || event.keyCode === 27) {
      // Find all possible drawers
      var drawers = document.querySelectorAll(settings.selectorTarget),
        i;

      // Find active drawers and close them when escape is clicked
      for (i = 0; i < drawers.length; ++i) {
        if (drawers[i].classList.contains(settings.activeClass)) {
          closeDrawer(drawers[i]);
        }
      }
    }
  };

  //
  // Inits & Event Listeners
  //
  document.addEventListener("click", clickHandler, false);
  document.addEventListener("keydown", keydownHandler, false);
};
drawer();

// jQuery(document).ready(function ($) {
//   new fullpage(".science-benefits #fullpage", {
//     sectionSelector: ".shopify-section",
//   });
// });
